import { Component, Vue } from 'vue-property-decorator'

// apis
import { getDutyCycleData } from '@/api/dashboard'

// tools
import StateMachine from '@/class/stateMachine'
import { refreshToken } from '@/utils/tokenExpire'
import { fixedRound, getVal } from '@/utils/index'

/**
 * 计算幂
 * @param value 值
 * @param expectNum 期望开多次方后压到的最大值（大于1）
 * @param exponential 初始计算的次方
 * */
const calcExponential = (value:number, expectNum:number, exponential:number = 2):number => {
  const val = Math.pow(value, 1 / exponential)
  return val <= expectNum ? exponential : calcExponential(value, expectNum, exponential + 1)
}

@Component({
  name: 'DutyCycleMixin'
})
export default class extends Vue {
  dutyCycleMachine: StateMachine = new StateMachine()

  dutyCycleLastUpdate: string = '--' // duty cycle 最新更新时间
  dutyCycleUpdateCycle: string = '--'

  dutyCycleChartCount: number = 0 // duty cycle 图表总数
  singleCarouselCount: number = 3 // duty cycle 轮播单页元素数
  get dutyCycleCarouselItemCount() { // duty cycle 轮播页数
    return Math.ceil(this.dutyCycleChartCount / this.singleCarouselCount)
  }

  get dutyCycleItemHeight() {
    const v = fixedRound(1 / this.singleCarouselCount)
    const vPercent = (+v) * 100
    return `height: calc(${vPercent}% - 10px)`
  }

  bubbleChartRenderData: Array<Array<Object>> = [] // 气泡图渲染数据

  async getDutyCycleData(selectors) {
    this.dutyCycleMachine.changeState('reload')
    try {
      const { data } = await getDutyCycleData({
        headers: {
          oem: encodeURIComponent(selectors.oem.join(',')),
          platform: encodeURIComponent(selectors.platform.join(',')),
          userGroup: encodeURIComponent(selectors.userGroup.join(','))
        }
      })
      // const data = { lastTime: '暂无', data: [{ name: '西北地区', Data: [{ area: '西北地区', engine_speed_section: 650.0, torque_section: '50', duty_cycle_hb_count: 2.0, province_name: '宁夏' }, { area: '西北地区', engine_speed_section: 150.0, torque_section: '50', duty_cycle_hb_count: 3.0, province_name: '山西省' }, { area: '西北地区', engine_speed_section: 650.0, torque_section: '50', duty_cycle_hb_count: 3.0, province_name: '山西省' }, { area: '西北地区', engine_speed_section: 650.0, torque_section: '50', duty_cycle_hb_count: 3.0, province_name: '新疆' }, { area: '西北地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '甘肃省' }, { area: '西北地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '陕西省' }, { area: '西北地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '青海省' }] }, { name: '西南地区', Data: [{ area: '西南地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '云南省' }, { area: '西南地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '四川省' }, { area: '西南地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '西藏' }, { area: '西南地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '贵州省' }, { area: '西南地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '重庆市' }] }, { name: '中东部地区', Data: [{ area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '上海市' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '内蒙古' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '北京市' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '吉林省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '天津市' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '安徽省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '山东省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '广东省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '广西省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '江苏省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '江西省' }, { area: '中东部地区', engine_speed_section: 650.0, torque_section: '50', duty_cycle_hb_count: 3.0, province_name: '河北省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '河南省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '浙江省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '海南省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '湖北省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '湖南省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '福建省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '辽宁省' }, { area: '中东部地区', engine_speed_section: null, torque_section: null, duty_cycle_hb_count: null, province_name: '黑龙江省' }] }], x: ['600', '800', '1000', '1200', '1400', '1600', '1800', '2000', '2200', '2400', '2600', '2800', '3000'], y: ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'], pl: '暂无' }
      this.dutyCycleLastUpdate = data.lastTime
      this.dutyCycleUpdateCycle = data.pl
      this.dutyCycleChartCount = data.data.length

      // @ts-ignore
      this.bubbleChartRenderData = Object.freeze(this.adaptBubbleChartRenderData(data.data, data.x, data.y))

      this.$nextTick(() => {
        this.bubbleChartRenderData.forEach((bubbleChartWrapper, bubbleChartWrapperInd) => {
          bubbleChartWrapper.forEach((bubbleChart, bubbleInd) => {
            // @ts-ignore
            const bubbleChartRef = getVal(() => this.$refs[`dutyCycle_${bubbleChartWrapperInd}_${bubbleInd}`][0], false)

            if (bubbleChartRef) {
              bubbleChartRef.drawChart({
                tooltip: {
                  trigger: 'item'
                },
                grid: {
                  top: '8%',
                  left: '5%',
                  right: '8%',
                  bottom: '5%',
                  containLabel: true
                },
                dataset: {
                  // @ts-ignore
                  source: bubbleChart.bubbleData
                },
                xAxis: {
                  type: 'value',
                  // @ts-ignore
                  data: bubbleChart.x,
                  axisLine: {
                    lineStyle: {
                      color: '#999'
                    }
                  },
                  splitLine: {
                    show: false
                  },
                  // interval: (bubble.x.slice(-1)[0] - bubble.x[0]) / (bubble.x.length - 1),
                  // @ts-ignore
                  min: bubbleChart.x[0],
                  // @ts-ignore
                  max: bubbleChart.x.slice(-1)[0]
                },
                yAxis: {
                  type: 'value',
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#999'
                    }
                  },
                  splitLine: {
                    show: false,
                    lineStyle: {
                      color: '#999'
                    }
                  },
                  scale: true,
                  // @ts-ignore
                  data: bubbleChart.y,
                  axisLabel: {
                    formatter: '{value} %'
                  }
                },
                series: [{
                  type: 'scatter',
                  symbolSize: function(value) {
                    const proportion = calcExponential(value[4], 8) // 将值压到 1 - 8 范围内
                    const baseBubble = Math.pow(value[2], 1 / proportion)
                    return baseBubble * 2
                  },
                  tooltip: {
                    confine: true,
                    formatter: function(params) {
                    // @ts-ignore
                      return `转速：${params.value[0]} <br> 扭矩：${params.value[1]}% <br>百分比：${fixedRound(params.value[2] / params.value[5] * 100)}% `
                    }
                  },
                  itemStyle: {
                    shadowBlur: 3,
                    shadowOffsetY: 3,
                    color: function(params) {
                      const proportion = calcExponential(params.value[4], 8) // 将值压到 1 - 8 范围内
                      const baseBubble = Math.pow(params.value[2], 1 / proportion)
                      const valPercent = +fixedRound(baseBubble / 8)

                      if (valPercent <= 0.4) {
                        return 'rgba(211, 124, 97, .1)'
                      } else if (valPercent <= 0.6) {
                        return 'rgba(211, 124, 97, .2)'
                      } else {
                        return 'rgba(211, 124, 97, 1)'
                      }
                    }
                  }
                }]
              })
            }
          })
        })
      })

      this.dutyCycleMachine.changeState('resolve')
    } catch (error) {
      if (error instanceof Error) {
        if (error.message === '401:expired') {
          await refreshToken()
          location.reload()
        }

        if (error.message !== '402:abort') {
          console.error('获取 dutyCycle 数据失败！')
          this.dutyCycleMachine.changeState('reject')
        }
      }
    }
  }

  adaptBubbleChartRenderData(dataSet, x, y) {
    if (!dataSet.length) return []

    const final: Array<Array<object>> = []
    for (let i = 0; i < this.dutyCycleCarouselItemCount; i++) {
      final.push([])
    }

    let secInd = 0

    dataSet.forEach((bubbleData, bubbleInd) => {
      const pageItemRemain = bubbleInd % this.singleCarouselCount
      const maxBubbleVal = Math.max(...bubbleData.Data.map(data => data.duty_cycle_hb_count))
      const maxCountBubbleVal = bubbleData.Data.reduce((acc, currVal) => {
        return acc + currVal.duty_cycle_hb_count
      }, 0)
      final[secInd].push({
        name: bubbleData.name,
        bubbleData: bubbleData.Data.map(bubble => {
          return [bubble.engine_speed_section, bubble.torque_section, bubble.duty_cycle_hb_count, bubble.province_name, maxBubbleVal, maxCountBubbleVal]
        }),
        x,
        y
      })

      if (pageItemRemain === (this.singleCarouselCount - 1)) secInd += 1
    })

    return final
  }
}
